/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { IconButton } from "@material-ui/core";
import { CopyButton } from "../../modules/agentConsole/components/Common/CopyButton";

const CopyIconButton = ({ value = "", styles = {} }) => {
	return (
		<span style={{ marginTop: -5 }}>
			<IconButton size="small" onClick={(e) => e.stopPropagation()}>
				<CopyButton value={value} style={{ width: "25px", color: "#707070", ...styles }} />
			</IconButton>
		</span>
	);
};

export default CopyIconButton;
